import React from "react";
import AboutValue from "./about-page/AboutValue.js";
import AboutChoice from "./about-page/AboutChoice.js";
import AbouTeam from "./about-page/AbouTeam.js";
import Abouttest from "./about-page/Abouttest.js";
import AboutFoot from "./about-page/AboutFoot.js";
import AboutHero from "./about-page/AboutHero.js";
import KeyFeatures from "./about-page/KeyFeatures.js";

const About = () => {
  return (
    <div className="">
    
      <AboutHero/>
      <AboutValue/>
      <KeyFeatures/>
      <AbouTeam/>
      <AboutChoice/>
      <Abouttest/>
      <AboutFoot/>
  
    </div>
  );
};

export default About;